import React from 'react';
import { Types as AnnouncementTypes } from '../../constants/announcementTypes';
import dangerIcon from '../../assets/images/icons/announcements/danger.svg';
import alertIcon from '../../assets/images/icons/announcements/alert.svg';
import checkIcon from '../../assets/images/icons/announcements/check.svg';
import formIcon from '../../assets/images/icons/announcements/form.svg';
import { MODALS } from '../../config/images';
import PdfViewerBlob from './PdfViewerBlob';
const iconMap = {
  1: dangerIcon,
  2: alertIcon,
  3: checkIcon,
  4: formIcon,
};

export default function AdHomeModal({
  isOpen,
  activeAds,
  currentAdIndex,
  onClose,
}) {
  if (!isOpen || !activeAds?.length) return null;

  const ad = activeAds[currentAdIndex];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70">
      <div className="relative w-full max-w-2xl max-h-[85%] overflow-y-scroll  bg-white shadow-2xl rounded-2xl">
          <button
            onClick={onClose}
            className="absolute top-0 right-0 px-2 py-2 "
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>

        {(ad.title || ad.manual?.title) && (
          <div className="px-6 pt-6 pb-4 border-b">
            <h2 className="text-xl text-gray-800 font-itcmedium">
              {ad.title || ad.manual?.title || 'Anuncio'}
            </h2>
            {ad.summary && <p className="mt-1 text-gray-600 font-itcbook">{ad.summary}</p>}
          </div>
        )}
        <div className={
          `p-6 flex ` +
          (ad.typeId === AnnouncementTypes.Advertisement
            ? 'justify-start'
            : 'justify-center')
        }>
          {(() => {
            switch (ad.typeId) {
              case AnnouncementTypes.Image:
                return <img src={ad.file_url} alt={ad.title} className="max-h-[500px] object-contain rounded" />;
              case AnnouncementTypes.Pdf:
                return <PdfViewerBlob pdfUrl={ad.file_url} title={ad.summary} />;
              case AnnouncementTypes.Video:
                return <video src={ad.file_url} controls className="max-h-[500px] w-full object-contain rounded" />;
              case AnnouncementTypes.Advertisement:
                return (
                  <div className='flex items-start justify-between gap-3 md:flex-row'>
                    <img
                      src={iconMap[ad.iconId]}
                      alt="icono"
                      className="w-16 h-16 "
                    />
                    <div
                      className="flex-1 prose max-w-none font-itcbook"
                      dangerouslySetInnerHTML={{ __html: ad.description }}
                    />
                  </div>
                );
              case AnnouncementTypes.Recents:
                return <PdfViewerBlob pdfUrl={ad.manual.file} title={ad.summary} />;
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
}
